<template>
  <div :class="$style.timeline">
    <div
      v-for="logGroup in grouppedLogItems"
      :key="logGroup[0].account"
      :class="{
        [$style.timelineGroup]: true,
        [$style.singleton]: logGroup.length === 1
      }"
    >
      <div :class="$style.photoShaft">
        <div :class="$style.photo">
          <ui-avatar
            :src="getLogPhoto(logGroup[0])"
            size="m"
          />
        </div>
      </div>

      <div
        v-for="logItem in logGroup"
        :key="getKey(logItem)"
        :class="$style.timelineGroupItem"
      >
        <slot
          name="item"
          :log-item="logItem"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, defineComponent } from 'vue';
import { UiAvatar } from '@huntflow/ui';
import type { ApplicantLog } from '@/shared/legacy/types/applicant-log';
import type { Applicant } from '@/shared/legacy/types/applicant';
import { PhotoHelper } from '@/modules/applicant-photo-editor/helper';
import { EntityType } from '@/shared/legacy/api/photo';
import { LogItemType } from '@/shared/legacy/types/log-item-type';

const { logItems, getKey, applicant } = defineProps<Props>();

defineComponent({
  name: 'LogItemsTimeline'
});

type Props = {
  logItems: Array<ApplicantLog>;
  applicant: Applicant;
  getKey: () => any;
};
const grouppedLogItems = computed(() => {
  const groups: ApplicantLog[][] = [];
  let latestAccount = null;
  logItems.forEach((logItem) => {
    if (latestAccount !== logItem.account) {
      latestAccount = logItem.account;
      groups.push([]);
    }
    groups[groups.length - 1].push(logItem);
  });
  return groups;
});

function getLogPhoto(logItem) {
  const isResponse = logItem.type === LogItemType.RESPONSE;
  let data;
  if (isResponse) {
    data = {
      entity: applicant,
      type:
        logItem.status === 'response' // у лога статус может быть любой статус и для откликов надо это учитывать
          ? EntityType.APPLICANT_RESPONSE // это для лога в разделе с откликами
          : EntityType.APPLICANT // а это когда мы кандидата взяли из откликов в работу
    };
  } else {
    data = {
      entity: logItem?.account_info ?? {},
      type: EntityType.USER
    };
  }
  return PhotoHelper.getPhotoUrl(data);
}
</script>

<style module>
.timelineGroup {
  position: relative;
}

.timelineGroup + .timelineGroup {
  margin-top: 20px;
}

.photoShaft {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  height: 100%;
  width: 44px;
}

.photo {
  position: sticky;
  top: 8px;
  left: 0;
  margin-bottom: 5px;
}

.timelineGroupItem {
  position: relative;
  padding-left: 56px;

  &::before {
    content: '';
    width: 7px;
    height: 7px;
    position: absolute;
    left: 18px;
    top: 5px;
    border-radius: 50%;
    border: 1px solid $black-12;
  }

  &::after {
    content: '';
    position: absolute;
    top: 14px;
    bottom: -25px;
    width: 1px;
    background-color: $black-12;
    left: 22px;
  }
}

.timelineGroupItem:last-of-type::after {
  bottom: 0;
}

.timelineGroupItem + .timelineGroupItem {
  margin-top: 20px;
}

.singleton {
  .timelineGroupItem::before,
  .timelineGroupItem::after {
    display: none;
  }
}

.timelineGroup:last-of-type .timelineGroupItem:last-of-type {
  padding-bottom: 24px;

  &::after {
    bottom: 24px;
  }
}

.timelineGroup:last-of-type .photo {
  margin-bottom: 29px;
}
</style>

<i18n lang="json">{}</i18n>
